export default __webpack_public_path__ + "static/media/353.c5e849df.png";